// Run `callback` once, on the visitor's first interaction with the page.
const DOCUMENT_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'mousemove', 'wheel'];

export default (callback = () => {}) => {
    let fired = false;

    const handler = () => {
        if (fired) {
            return;
        }
        fired = true;
        DOCUMENT_EVENTS.forEach((type) => document.removeEventListener(type, handler));
        window.removeEventListener('scroll', handler);
        callback();
    };

    DOCUMENT_EVENTS.forEach((type) => document.addEventListener(type, handler, {once: true, passive: true}));
    window.addEventListener('scroll', handler, {once: true, passive: true});
};
